import { PageTemplate } from "@/components/Templates/PageTemplate";

export default function SiteStartUpMilestones() {
  return (
    <PageTemplate
      title="Sites: Site Start Up Milestones"
      tooltipText="Explore site start up milestone data across study sites."
      type="site-activation-milestone"
      selectionIdentifierColumn="site"
      constants={{
        wikiLink: "/wiki/guides/exploration-dashboard-studio-overview",
        idLink: undefined,
      }}
    />
  );
}
